import { Caption } from 'blaze-ui/icons'
import { HoverActionOverlay, HoverActionOverlayProps } from 'components/HoverActionOverlay/HoverActionOverlay'
import { EditCaptionButton } from 'screens/Calendar/FullScreenPreview/EditPostMenu/EditCaptionButton'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useAuth } from 'hooks/UseAuth'

export const EditCaptionOverlay = ({
  almanacFileKey,
  scheduledPost,
  ...props
}: Omit<HoverActionOverlayProps, 'onAction' | 'buttonLabel'> & {
  scheduledPost: ScheduledPostShow
  almanacFileKey: string
}) => {
  const auth = useAuth()
  const isDynamicCaptionsEnabled = useFlipperFlag('dynamic_captions')

  if (!auth) return <>{props.children}</>

  return (
    <HoverActionOverlay
      {...props}
      buttonLabel="Edit Caption"
      scrimOpacity={0}
      button={
        <EditCaptionButton
          scheduledPost={scheduledPost}
          almanacFileKey={almanacFileKey}
          variant="secondary"
          frontIcon={Caption}
          vertical={false}
          justifyContent="center"
          fullWidth={false}
          label={isDynamicCaptionsEnabled ? 'Edit Captions' : 'Edit Caption'}
          {...props.buttonProps}
        />
      }
    >
      {props.children}
    </HoverActionOverlay>
  )
}
